var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1488 0.146911L0.147349 16.1484C-0.166093 16.4618 0.0562639 17.0002 0.500179 17.0002H16.5016C16.7772 17.0002 17.0006 16.7768 17.0006 16.5012V0.499775C17.0007 0.056491 16.4627 -0.166964 16.1488 0.146911ZM16.0027 16.0022H1.70491L4.24276 13.4644L4.93784 14.1595C5.03528 14.2569 5.16299 14.3056 5.29067 14.3056C5.73126 14.3056 5.95877 13.769 5.6435 13.4537L4.94842 12.7587L6.37182 11.3353L7.0669 12.0304C7.16434 12.1278 7.29205 12.1765 7.41973 12.1765C7.86032 12.1765 8.08783 11.6399 7.77256 11.3246L7.07751 10.6296L8.50091 9.2062L9.19599 9.90128C9.29343 9.99872 9.42114 10.0474 9.54882 10.0474C9.98941 10.0474 10.2169 9.51083 9.90165 9.19556L9.2066 8.50051L10.63 7.07711L11.3251 7.77219C11.4225 7.86963 11.5502 7.91833 11.6779 7.91833C12.1185 7.91833 12.346 7.38173 12.0307 7.06646L11.3357 6.37141L12.7591 4.94802L13.4542 5.6431C13.5516 5.74054 13.6793 5.78924 13.807 5.78924C14.2476 5.78924 14.4751 5.25264 14.1598 4.93737L13.4648 4.24232L16.0026 1.70448V16.0022H16.0027Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9212 8.39691L8.39686 12.9212C8.08342 13.2347 8.30578 13.7731 8.74969 13.7731H13.274C13.5496 13.7731 13.773 13.5497 13.773 13.2741V8.74977C13.773 8.30649 13.2351 8.08304 12.9212 8.39691ZM12.775 12.7751H9.95442L12.775 9.95447V12.7751Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.4297d966053afd766bf32f01c5afeeec.svg";
export { ForwardRef as ReactComponent };